import { useLang } from "@/i18n/LanguageContext";

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <span className="lang-toggle">
      <button type="button" aria-pressed={lang === "nl"} onClick={() => setLang("nl")}>NL</button>
      <button type="button" aria-pressed={lang === "en"} onClick={() => setLang("en")}>EN</button>
    </span>
  );
}
